module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/3261dd341a6ec76280bd08769a2346f3.svg";